import { useState } from "react";
import { Button } from "@chakra-ui/react";

import { useWalletClient } from "wagmi";

import AddXSymbolMessageModal from "@components/AddXSymbolMessageModal";
import { trackEvent } from "utils";
import { ADD_TOKEN } from "@constants/analytics";

interface AddXSymbolProps {
  xSymbol: {
    address: `0x${string}`;
    symbol: string;
    decimals: number;
  };
}

const AddXSymbol = ({ xSymbol }: AddXSymbolProps) => {
  const [errorAddingXSD, setErrorAddingXSD] = useState("");
  const [shouldDisplayAddXSDModal, setShouldDisplayXSDModal] = useState(false);
  const [isTxnProcessing, setIsTxnProcessing] = useState(false);

  const { data: signer } = useWalletClient();

  const addXTokenToWallet = async () => {
    if (!signer) {
      return;
    }
    setIsTxnProcessing(true);
    setShouldDisplayXSDModal(true);
    trackEvent(ADD_TOKEN, { symbol: xSymbol.symbol });

    try {
      await signer.watchAsset({
        type: "ERC20",
        options: {
          address: xSymbol.address,
          symbol: xSymbol.symbol,
          decimals: xSymbol.decimals,
        },
      });
    } catch (error) {
      const err = error as any;
      if (err instanceof Error || err?.message) {
        setErrorAddingXSD(err.message);
      } else {
        setErrorAddingXSD(`Error Adding ${xSymbol.symbol}`);
      }
    } finally {
      setIsTxnProcessing(false);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        border="1px"
        borderRadius="6px"
        borderColor="textPrimary"
        fontSize="10px"
        fontWeight="500"
        ml="8px"
        h="24px"
        p="4px 16px"
        onClick={addXTokenToWallet}
        color="textPrimary"
      >
        Add {xSymbol.symbol}
      </Button>

      {shouldDisplayAddXSDModal && (
        <AddXSymbolMessageModal
          isOpen={shouldDisplayAddXSDModal}
          onCancel={() => {
            setShouldDisplayXSDModal(false);
            setErrorAddingXSD("");
          }}
          error={errorAddingXSD}
          isTxnProcessing={isTxnProcessing}
          token={xSymbol.symbol}
        />
      )}
    </>
  );
};

export default AddXSymbol;
